import React, { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { trackBetLimitError } from '@mobi/account/Common/Analytics'
import { useHostContext } from '@mobi/account/Common/HostContext'
import { PageStyled } from '@mobi/account/Common/Styles'
import { get, queryKeys } from '@mobi/account/Utils'
import { precommitmentUrl } from '@mobi/account/Utils'
import { AccountHeader } from '@mobi/component-library/Areas/Account'
import { Spinner } from '@mobi/component-library/Legacy/Spinner'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { BetLimitForm } from './BetLimitForm'

export type PrecommitmentResponse = {
  BetLimit?: number
  ProposedBetLimit?: { Amount: number; ActiveDate: string }
  ProposedCreditCardReleaseDate: string | null
  BlockCreditCardDeposits: boolean
  BlockCreditCardDepositsEnable: boolean
  CoolingOffPeriodDays: number
  CoolingOffDate: string
  BetLimitRange: { Min: number; Max: number }
  RwwaAccountsContactTel: string
}

export const BetLimitPage: React.FC = () => {
  const { channel } = useHostContext()
  const { isLoading, isError, data } = useQuery<PrecommitmentResponse>({
    queryKey: queryKeys.precommitmentDetails,
    queryFn: () => get(precommitmentUrl.precommitmentDetails),
    retry: false,
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (isError) trackBetLimitError('Unable to display your current bet limit')
  }, [isError])

  return (
    <>
      {channel === 'mobile' && <PageHeader title='Bet Limit' />}
      <PageStyled>
        {channel === 'desktop' && <AccountHeader alignItems='start' title='Bet limit' />}
        {isLoading ? (
          <Spinner />
        ) : (
          <BetLimitForm precommitmentDetails={data} hasDataFetchFailed={isError} />
        )}
      </PageStyled>
    </>
  )
}
